
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23.295 19.654"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.294 11.647l-4.368-4.368V.728h-2.911v3.64L11.647 0 0 11.647v.728h2.912v7.279h7.279v-4.367H13.1v4.368h7.279v-7.28h2.912z","fill":"#005f9e"}})])
          )
        }
      }
    